var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-wrapper',[_c('page-header',[_c('h1',[_vm._v(_vm._s(_vm.$tc('views.admin.settings.title', 2))+" ("+_vm._s(_vm.$tc('common.term.dashboard'))+")")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }